import React,{useState} from "react";
import { isAuthenticated } from '../auth';
import { createImageProduct } from "../auth/apiProduct";
import ErrorAlert from "../pageInside/ErrorAlert";
import ShowimagesLoading from "./showImagesLoading";
import { buildProductEditPath } from "../../utils/publicIdentifier";
import { getImageFileError, IMAGE_ACCEPT, MAX_IMAGE_SIZE_MB } from "../../utils/imageUploadLimits";
import "./imagesLoading.css"
import { elakayAutoText } from "./dataElakay";


const checkImageBackground = async (file, colorList) => {
    if (!file || !colorList) return false;

    return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const img = new Image();

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.width = img.width;
                canvas.height = img.height;

                context.drawImage(img, 0, 0, canvas.width, canvas.height);

                const pixelData = context.getImageData(0, 0, 1, 1).data;

                const hexColor = `#${((1 << 24) + (pixelData[0] << 16) + (pixelData[1] << 8) + pixelData[2])
                    .toString(16)
                    .slice(1)}`;

                // Normalize both hexColor and colorList to lowercase
                const normalizedColorList = colorList?.map((color) => color.toLowerCase());
                resolve(normalizedColorList.includes(hexColor.toLowerCase()));
            };

            img.onerror = () => resolve(false); // Handle error case
            img.src = e.target.result;
        };

        reader.onerror = () => resolve(false); // Handle error case
        reader.readAsDataURL(file);
    });
};


const ImagesLoading = props => {
    const { token } = isAuthenticated();
    const {
        laguangeElakay,
        infoSource,
        maxImgSize = 6,
        imgSize,
        namProduct,
        setValues,
        values,
        productIDEdit,
        filterID,
        setGetUrl,
        // Optionnels -- flux non-Seller (ex. Provider Product) : `uploadImage(file)`
        // remplace createImageProduct (résout `{error}` en cas d'échec), puis
        // `onUploaded()` remplace setValues/setGetUrl. Absents = comportement
        // Seller inchangé.
        uploadImage,
        onUploaded
    } = props
    const [error, setError] = useState(null);
    const [rejected, setRejected] = useState([]);
    // Texte i18n (frontElakayHardcodedText.imagesLoadingAdd) avec repli anglais.
    const txt = (key, fallback, vars = {}) => {
        let out;
        try {
            out = infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).imagesLoadingAdd[key];
        } catch (e) { out = undefined; }
        return String(out || fallback).replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : k === "max" ? MAX_IMAGE_SIZE_MB : m));
    };
   const[post, setPost]=useState({
    title:"",
    desc:"",
   photos:[]
})


const [highlight, setHighlight] = useState(false)
const {title, desc, photos} = post
let sizeImg =  photos?.length + imgSize 
const handlechange = e =>{
    setPost({
        ...post,
        [e.target.name]: e.target.value
    })
}
const handlefilechange = e =>{
handleFiles(e.target.files);
// Réinitialise l'input : on peut resélectionner immédiatement le même fichier.
e.target.value = "";
}

const handleFiles0 =  (files)=>{
    let arrPhotos = [];
    let sizeArr
    for (let file of files){
      
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener('load', ()=>{
            // if (file) {
            //     const allowedColors = ['#F8F8FF', '#FFFFFF', "#F5F5F5", "#FFFAFA", "#F5FFFA"]; // Example allowed colors
            //     const isAllowed = checkImageBackground(file, allowedColors);
            // alert(isAllowed ? "Background color is allowed!" : "Background color is not allowed!");
            // }

            let fileobj ={
                file: file,
                name : file.name,
                type: file.type,
                size: file.size,
                src: reader.result
            }
        arrPhotos.push(fileobj)
        if(( sizeImg+ files?.length) > maxImgSize){
            sizeArr = files?.length -  ((sizeImg + files?.length) - maxImgSize)
        }else{
            sizeArr =   files?.length
        }
        setPost({
            ...post,
            photos:[...photos, ...arrPhotos.slice(0, sizeArr)]
        })
        });  
    }
    
}

const handleFiles = async (files) => {
    const list = Array.from(files || []);
    const rejectedNow = [];
    const valid = [];

    // Validation avant toute lecture/envoi : une image invalide est signalée
    // individuellement, les autres continuent normalement.
    for (const file of list) {
        const reason = getImageFileError(file);
        if (reason === "type") rejectedNow.push({ name: file.name, message: txt("badType", "Unsupported format. Please use JPG, PNG or WebP.") });
        else if (reason === "size") rejectedNow.push({ name: file.name, message: txt("tooLarge", "Image too large. Maximum allowed size is {max} MB.") });
        else valid.push(file);
    }
    setRejected(rejectedNow);

    // Nombre d'images encore acceptées (plafond maxImgSize inchangé).
    const room = Math.max(0, maxImgSize - sizeImg);
    const accepted = valid.slice(0, room);

    const arrPhotos = [];
    for (const file of accepted) {
        const src = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        }).catch(() => null);
        if (src === null) continue;
        arrPhotos.push({ file, name: file.name, type: file.type, size: file.size, src });
    }

    if (arrPhotos.length) {
        setPost(prev => ({ ...prev, photos: [...prev.photos, ...arrPhotos] }));
    }
};

const handledelete = e =>{
    let target = e.target.parentElement;
    
    let tagetIndex = target.dataset.imgindex * 1;
setPost({
...post,
photos:[...photos.slice(0, tagetIndex), ...photos.slice(tagetIndex + 1)]
})
    
}

const handlehighlight = e =>{
e.preventDefault();
e.stopPropagation();
setHighlight(true);
}

const handleunhighlight = e =>{
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
}

const handledrop = e =>{
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
    let dt = e.dataTransfer;
    let files = dt.files
    handleFiles(files)
}

const handleSubmit= async (event)=> {
event.preventDefault();
    if (uploadImage) {
        // Séquentiel : l'ordre choisi est conservé et le plafond serveur d'images
        // reste vérifié à chaque envoi.
        for (const f of photos) {
            const data = await uploadImage(f.file);
            if (data?.error) return setError(data.error);
        }
        setError(null);
        setPost({ ...post, photos: [] });
        return onUploaded && onUploaded();
    }
    // One photo after the other (UP-08): the server accepts only a few
    // concurrent uploads per process and refused parallel bursts with 503.
    for (const f of photos || []) {
        const data = await createImageProduct(token, filterID, productIDEdit, f.file);
        if (data.error) {
            setError(data.error);
            return;
        }
        setError(null)
        setGetUrl(buildProductEditPath({}, productIDEdit))
        setValues({
            ...values,
            inpProduct: false,
            filterProduct: false,
            imgPreview: false,
            productID: data.productID,
            redirectToFilter: true,
            loading: false,
            });
    }
}

    const ImagesForm = () => (
        <div className="row mt-4 justify-content-center">
        <div className="col col-12 col-md-10 col-lg-9 p-2" >
        <div className="file-upload">
        <h2>{namProduct}</h2>
        <form className="" encType= "multipart/form-data"> 
        <div className="custom-file-preview">
                  {photos?.length > 0 && photos?.map((a, i) =>(
                    <div className="prev-img" key={i} data-imgindex={i}>
                        <span role="button" aria-label={txt("remove", "Remove image")} onClick={handledelete}>&times;</span>
                        <ShowimagesLoading className="imgLoad" src={a.src} alt={a.name}/>
                    </div>
                    ))}
                </div>
            <div className="custom-form-group">
         {   sizeImg < maxImgSize ?
                <div className={highlight? "custom-file-drop-area highlight": "custom-file-drop-area"} 
                onDragEnter={handlehighlight}
                onDragOver={handlehighlight}
                onDragLeave={handleunhighlight}
                onDrop={handledrop}
                >
                    <input type="file" name="photos" accept={IMAGE_ACCEPT} placeholder={txt("t001", "Add photos")} multiple id="filephotos" onChange={handlefilechange}/>
                    <label htmlFor="filephotos"> 
                        {txt("addUpTo", "Add up to {n} more images", { n: maxImgSize - sizeImg })}
                        <br/>
                        {txt("dragDrop", "or drag and drop them here")}
                        <br/>
                        <small className="d-block mt-1 text-muted" style={{ overflowWrap: "anywhere" }}>{txt("maxSize", "Maximum size: {max} MB per image.")}</small>
                         </label>
                </div>
                :
                <div className={sizeImg < maxImgSize? "custom-file-drop-area": "custom-file-drop-area redlight"}>
                    <label htmlFor="filephotos">
                         {txt("maxReached", "Maximum number of images reached.")}
                         </label>
                </div>
}
               
            </div>
            {rejected.length > 0 && (
                <div className="alert alert-danger mt-2 mb-0 small" role="alert" style={{ overflowWrap: "anywhere" }}>
                    <button type="button" className="close" aria-label={elakayAutoText("h_bbfa773e5a63a5", "Close")} onClick={() => setRejected([])}><span aria-hidden="true">&times;</span></button>
                    {rejected.map((r, i) => (
                        <div key={i}><strong>{r.name}</strong>{" : "}{r.message}</div>
                    ))}
                </div>
            )}
        </form>
     <ErrorAlert error={error} setError={setError} duration={10000} />
  <div>
   { photos?.length > 0 ?
    <button  className="btn btn-primary float-right pb-2" onClick={handleSubmit}>
        {infoSource.language(infoSource, 'Button', "submit")}
        </button>
   :
    <button  className="btn btn-secondary float-right pb-2" >
        {infoSource.language(infoSource, 'Button', "submit")}
        </button>}
  </div>
 </div>
     </div>
     </div>

    )

 
    return ImagesForm()
    
}
export default ImagesLoading;